import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import { GetCaseOverviewRes } from '@/api/types/queries';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const useGetCaseOverview = (caseId: string | null = '') => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getCaseOverview = async (): Promise<GetCaseOverviewRes> => {
    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/overview`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching case overview failed');
    }

    return response.json();
  };

  return useQuery([QueryEntity.CaseOverview, caseId], getCaseOverview, {
    refetchOnWindowFocus: false,
  });
};

export default useGetCaseOverview;
